// extracted by mini-css-extract-plugin
export default {"root":"PaginationControls_root__nAul5","button":"PaginationControls_button__SN+IK"};